import { render, staticRenderFns } from "./RealityModal.vue?vue&type=template&id=2bca8d63&scoped=true&"
import script from "./RealityModal.vue?vue&type=script&lang=js&"
export * from "./RealityModal.vue?vue&type=script&lang=js&"
import style0 from "./RealityModal.vue?vue&type=style&index=0&id=2bca8d63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bca8d63",
  null
  
)

export default component.exports